import { MsalProvider } from "@azure/msal-react";
import { mergeStyles } from "@fluentui/react";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import App from "./App";
import msal from "./common/msal";
import store from "./store/store";

import "./styles/styles.css";

// Inject some global styles
mergeStyles({
  selectors: {
    ":global(body), :global(html), :global(#app)": {
      margin: 0,
      padding: 0,
      height: "100vh",
    },
  },
});

const render = () => {
  ReactDOM.render(
    <MsalProvider instance={msal}>
      <Provider store={store}>
        <App />
      </Provider>
    </MsalProvider>,
    document.getElementById("app"),
  );
};

render();

if (process.env.NODE_ENV === "development" && module.hot) {
  module.hot.accept("./App", render);
}
